import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalSendHandoff } from '@/pages/workspaces/transactional/message/overview/send/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/send',
)({
  component: JourneysTransactionalSendHandoff,
});
